import { Grid } from "@mui/material";
import { required, TextInput } from "react-admin";

const SaveForm = () => {
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          label="Име на български език"
          source="nameBg"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          label="Име на английски език"
          source="nameEn"
          validate={required()}
        />
      </Grid>
    </Grid>
  );
};

export default SaveForm;
